import React, { Component, PropTypes } from 'react';
import { formatDate } from '../../utils/date';
import { lang } from '../../strings';
import { getApiUrl } from '../../utils/network';
import { trackEvent, INVOICE, GET } from '../../utils/analytics';

export default class InvoiceTable extends Component {

   render() {
      let { invoices } = this.props;

      return (
        <table className="mp-table">
           <thead>
           <tr>
              <th>{lang.invoices.invoiceNumber}</th>
              <th>{lang.invoices.customerNumber}</th>
              <th className="mp-xs-hidden">{lang.invoices.date}</th>
              <th>{lang.invoices.paid}</th>
              <th style={{textAlign: 'right'}}>{lang.invoices.amount}</th>
           </tr>
           </thead>
           <tbody>
           {invoices.map(invoice => {
              let { invoiceId, invoiceNumber, customerNumber, invoiceDate, amount, paidDate } = invoice;
              let invoiceUrl = getApiUrl() + '/invoices/' + encodeURIComponent(invoiceId);

              return (
                 <tr key={invoiceNumber}>
                    <td><a href={invoiceUrl} onClick={this.showInvoice}>{invoiceNumber}</a></td>
                    <td>{customerNumber}</td>
                    <td className="mp-xs-hidden">{formatDate(invoiceDate, 'L')}</td>
                    <td>{paidDate ? formatDate(paidDate, 'L') : '-'}</td>
                    <td style={{textAlign: 'right'}}>{amount.toLocaleString()} kr</td>
                 </tr>
              );
           })}
           </tbody>
        </table>
      );
   }

   showInvoice = () => {
       trackEvent(INVOICE, GET);
   }
}

InvoiceTable.propTypes = {
   invoices: PropTypes.array.isRequired
};
